export default {
    state: {
        cards: [],
        newCard: {}
    },
    mutations: {
        setCards (state, cards) {
            state.cards = cards
        },
        setNewCardValues (state, data) {
            state.newCard[data.id] = data.value
        },
        clearNewCardValues (state) {
            state.newCard = {}
        }
    },
    actions: {
        setCards ({ commit }, cards) {
            commit('setCards', cards)
        },
        setNewCardValues ({ commit }, data) {
            commit('setNewCardValues', data)
        },
        clearNewCardValues ({ commit }) {
            commit('clearNewCardValues')
        }
    },
    getters: {
        userCardList: (state) => state.cards,
        newCardValues: (state) => state.newCard
    }
}
